import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { FaCalendarAlt, FaUser, FaArrowLeft } from 'react-icons/fa';
import { blogs as staticBlogs } from '../data/products';

const BlogDetail = () => {
  const { id } = useParams();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchBlog();
  }, [id]);

  const fetchBlog = () => {
    const foundBlog = staticBlogs.find(b => b.id === id);
    setBlog(foundBlog);
    setLoading(false);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-IN', { year: 'numeric', month: 'long', day: 'numeric' });
  };

  if (loading) {
    return (
      <div className="min-h-screen pt-20 flex items-center justify-center" data-testid="loading-state">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-16 w-16 border-4 border-[#2E7D32] border-t-transparent"></div>
          <p className="mt-4 text-[#4E5D50]">Loading blog post...</p>
        </div>
      </div>
    );
  }

  if (!blog) {
    return (
      <div className="min-h-screen pt-20 flex items-center justify-center" data-testid="not-found">
        <div className="text-center">
          <h2 className="text-3xl font-bold text-[#1B3322] mb-4">Blog Post Not Found</h2>
          <p className="text-[#4E5D50] mb-6">The blog post you're looking for doesn't exist.</p>
          <Link
            to="/blog"
            className="inline-block bg-[#2E7D32] text-white px-8 py-3 rounded-full font-semibold hover:bg-[#1B5E20] transition-all"
          >
            Back to Blog
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen pt-20 bg-[#F1F8E9]" data-testid="blog-detail-page">
      <article className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Back Button */}
        <Link
          to="/blog"
          className="inline-flex items-center space-x-2 text-[#2E7D32] hover:text-[#1B5E20] mb-8 font-semibold"
          data-testid="back-button"
        >
          <FaArrowLeft />
          <span>Back to Blog</span>
        </Link>

        {/* Featured Image */}
        <div className="rounded-2xl overflow-hidden shadow-lg mb-8">
          <img
            src={blog.image_url}
            alt={blog.title}
            className="w-full h-96 object-cover"
            data-testid="blog-image"
          />
        </div>

        {/* Blog Content */}
        <div className="bg-white p-8 md:p-12 rounded-2xl shadow-lg">
          <div className="flex items-center gap-6 text-sm text-[#839385] mb-6">
            <span className="flex items-center gap-2">
              <FaUser />
              {blog.author}
            </span>
            <span className="flex items-center gap-2">
              <FaCalendarAlt />
              {formatDate(blog.created_at)}
            </span>
          </div>

          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-6 text-[#1B3322]" data-testid="blog-title">
            {blog.title}
          </h1>

          <div className="prose prose-lg max-w-none" data-testid="blog-content">
            {blog.content.split('\n').map((paragraph, index) => (
              paragraph.trim() && (
                <p key={index} className="text-lg text-[#4E5D50] mb-6 leading-relaxed">
                  {paragraph}
                </p>
              )
            ))}
          </div>
        </div>

        {/* CTA */}
        <div className="mt-12 bg-gradient-to-r from-[#2E7D32] to-[#0288D1] p-8 rounded-2xl text-white text-center">
          <h3 className="text-2xl font-bold mb-4">Have Questions About Drip Irrigation?</h3>
          <p className="mb-6 text-white">Our experts are here to help. Get in touch today!</p>
          <a
            href="https://wa.me/919110278059"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-[#25D366] text-white hover:bg-[#20BA5A] rounded-full px-8 py-4 font-semibold transition-all"
            data-testid="contact-whatsapp-button"
          >
            Contact Us on WhatsApp
          </a>
        </div>
      </article>
    </div>
  );
};

export default BlogDetail;